import React, { useState } from 'react';

import { moveToFolder } from '../../../../../data/apis/api';
import { useRestMutation } from '../../../../../data/util';
import { useImportState } from '../../useImportState';
import { FolderUploadTypes } from '../types';
import { TranspilerFileBrowser } from './TranspilerFileBrowser';

export const MoveToFolder = ({ onClose, pathToMove = '' }: { onClose: () => void; pathToMove?: string }) => {
  const [selectedPath, setSelectedPath] = useState('');

  const {
    transpilerState: { transpilerId },
    uploadMutationState: { setUpdatePath }
  } = useImportState();

  const resetPath = () => {
    onClose();
    setSelectedPath('');
  };

  const mutation = useRestMutation(
    (targetFilePath: string) => moveToFolder(transpilerId, { currentFilePath: pathToMove, targetFilePath }),
    {
      sentryTag: 'transpiler.moveToFolder',
      onSuccess: () => {
        resetPath();
        setUpdatePath(FolderUploadTypes.move);
      }
    }
  );

  return (
    <TranspilerFileBrowser
      selectedPath={selectedPath}
      pathToMove={pathToMove}
      loading={mutation.isLoading}
      onSubmit={(path) => mutation.mutateAsync(path)}
      onChange={(value) => setSelectedPath(value)}
      toggleFilePath={resetPath}
    />
  );
};
